export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.dr_mohamed_admin_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
